import { Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import type { Observable } from 'rxjs'

import {
  type CommentBoxAnchor,
  type CommentBoxSnapshot,
  type CommentPendingPickAnswer,
  type CommentTargetPayload,
  closeCommentBox,
  commentBox$,
  commentBoxAnchor$,
  commentTargetIfOnScreen,
  previewCommentLevel,
  reportCommentHasText,
  resolvePendingPick,
  selectCommentLevel,
} from '@flowx/core-sdk'

/**
 * The comment box's side of the channel with the SDK's comment layer: what the layer publishes and
 * the commands the box sends back. It is the seam the box and the store are specified against, so
 * their specs replace it instead of reaching for the module-level channel.
 */
@Injectable({ providedIn: 'root' })
export class CommentSessionService {
  /** What the box shows, or null while no comment is open. */
  readonly commentBox = toSignal<CommentBoxSnapshot | null>(commentBox$, { initialValue: null })

  /** Where the box goes: the pin and the scroller it stays inside. Follows scroll, so it is a
   * stream the box places from directly rather than a signal. */
  readonly anchor$: Observable<CommentBoxAnchor | null> = commentBoxAnchor$

  previewLevel(index: number | null): void {
    previewCommentLevel(index)
  }

  /** False when that level is gone. */
  selectLevel(index: number): boolean {
    return selectCommentLevel(index)
  }

  resolvePendingPick(answer: CommentPendingPickAnswer): void {
    resolvePendingPick(answer)
  }

  close(): void {
    closeCommentBox()
  }

  /** Null when the target is gone. */
  targetIfOnScreen(): CommentTargetPayload | null {
    return commentTargetIfOnScreen()
  }

  reportHasText(hasText: boolean): void {
    reportCommentHasText(hasText)
  }
}
